import React, { useEffect, useState } from 'react'

export default function AdminSignups () {
  const [apiKey, setApiKey] = useState(() => localStorage.getItem('adminApiKey') || '')
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!apiKey) return
    setLoading(true)
    setError(null)

    fetch('/api/v1/admin/beta-signups', {
      headers: { 'x-api-key': apiKey }
    })
      .then(async res => {
        if (res.status === 401) throw new Error('Invalid API key.')
        if (res.status === 500) throw new Error('Server misconfiguration — API_KEY not set.')
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        return res.json()
      })
      .then(setData)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false))
  }, [apiKey])

  function saveKey (value) {
    setApiKey(value)
    if (value) {
      localStorage.setItem('adminApiKey', value)
    } else {
      localStorage.removeItem('adminApiKey')
    }
    setData(null)
    setError(null)
  }

  return (
    <main className='min-h-screen bg-zinc-950 text-white px-6 py-10'>
      <div className='mx-auto max-w-5xl'>
        <h1 className='text-2xl font-semibold'>Beta Signups</h1>
        <p className='mt-2 text-sm text-zinc-400'>
          View everyone who signed up for the private beta.
        </p>

        <div className='mt-6 max-w-md'>
          <label className='block text-sm font-medium text-zinc-300'>
            Admin API Key
            <input
              type='password'
              className='mt-2 h-11 w-full border border-zinc-700 bg-zinc-900 px-3 text-white outline-none focus:border-emerald-600'
              value={apiKey}
              onChange={e => saveKey(e.target.value)}
              placeholder='Enter x-api-key'
            />
          </label>
        </div>

        {loading && <p className='mt-6 text-sm text-zinc-400'>Loading...</p>}

        {error && (
          <div className='mt-6 border border-red-800 bg-red-900/20 p-4 text-sm text-red-200'>
            {error}
          </div>
        )}

        {data && (
          <div className='mt-6'>
            <div className='mb-4 flex gap-6 text-sm'>
              <div className='text-zinc-400'>
                <span className='font-semibold text-white'>{data.total}</span> total
              </div>
              <div className='text-zinc-400'>
                <span className='font-semibold text-emerald-400'>{data.claimed}</span> claimed
              </div>
              <div className='text-zinc-400'>
                <span className='font-semibold text-amber-400'>{data.waitlist}</span> waitlist
              </div>
            </div>

            <div className='overflow-x-auto border border-zinc-800'>
              <table className='w-full text-left text-sm'>
                <thead className='bg-zinc-900 text-zinc-400'>
                  <tr>
                    <th className='px-4 py-3 font-medium'>Name</th>
                    <th className='px-4 py-3 font-medium'>Email</th>
                    <th className='px-4 py-3 font-medium'>Company</th>
                    <th className='px-4 py-3 font-medium'>Phone</th>
                    <th className='px-4 py-3 font-medium'>Status</th>
                    <th className='px-4 py-3 font-medium'>Created</th>
                  </tr>
                </thead>
                <tbody className='divide-y divide-zinc-800'>
                  {data.signups.map(s => (
                    <tr key={s.id} className='hover:bg-zinc-900/50'>
                      <td className='px-4 py-3'>{s.name}</td>
                      <td className='px-4 py-3 text-zinc-400'>{s.email}</td>
                      <td className='px-4 py-3 text-zinc-400'>{s.company || '-'}</td>
                      <td className='px-4 py-3 text-zinc-400'>{s.phone || '-'}</td>
                      <td className='px-4 py-3'>
                        <span className={`inline-block rounded px-2 py-0.5 text-xs font-medium ${
                          s.status === 'free'
                            ? 'bg-emerald-500/10 text-emerald-300'
                            : 'bg-amber-500/10 text-amber-300'
                        }`}>
                          {s.status}
                        </span>
                      </td>
                      <td className='px-4 py-3 text-zinc-500'>
                        {s.createdAt ? new Date(s.createdAt).toLocaleString() : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </main>
  )
}
